import {gsap} from "gsap";

export default class Accordion {
    constructor() {
        this.accordion = document.querySelectorAll('.js-accordion-wrapper');
        this.itemClass = ".js-accordion";
        this.contentWrapperClass = ".js-accordion-content";
        this.css = {
            open: "is-open"
        };

        // one item in list can be opened or not
        let mono = false;

        if (this.accordion.length > 0) {
            for (const accordion of this.accordion) {
                if (accordion.classList.contains('is-mono')) {
                    mono = true;
                }

                if (accordion.classList.contains('is-mobile') && window.innerWidth < 1001) {
                    this.init(accordion, mono);
                } else if(!accordion.classList.contains('is-mobile')) {
                    this.init(accordion, mono);
                }
            }
        }
    }

    init(accordion, mono) {
        let items = accordion.querySelectorAll(".js-accordion");
        for (let i = 0; i < items.length; i++) {
            items[i].addEventListener("click", ev => {
                ev.preventDefault();
                const current = ev.currentTarget;
                let contentWrapper = current.querySelector(this.contentWrapperClass);

                if (contentWrapper == null) {
                    contentWrapper = current.parentNode.querySelector(this.contentWrapperClass);
                }

                if (!current.classList.contains(this.css.open)) {
                    this.slideDown(current, contentWrapper, accordion, items, mono);
                    return;
                }

                this.closeItem(accordion, current);
            });
        }
    }

    getActiveElement(accordion, element) {
        let active = null;
        let accordionItems = accordion.querySelectorAll(`${this.itemClass}`);

        if (element.classList.contains(this.css.open)) {
            active = element;
            return active;
        }

        for (let i = 0; i < accordionItems.length; i++) {
            if (accordionItems[i].classList.contains(this.css.open)) {
                active = accordionItems[i];
            }
        }
        return active;
    }

    slideDown(element, content, accordion, items, mono) {
        const contentHeight = 0;
        const active = this.getActiveElement(accordion, element);

        if (active && mono) {
            const activeContent = active.querySelector(this.contentWrapperClass);
            const height = activeContent.offsetHeight;

            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove(this.css.open);
            }

            element.classList.add(this.css.open);

            gsap.set(activeContent, {
                height: height,
                onComplete: () => {
                    active.classList.remove(this.css.open);

                    gsap.to(activeContent, 0.6, {
                        height: 0,
                        onStart: () => {
                            this.openItem(content, contentHeight);
                        }
                    });
                }
            });
            return;
        }
        // else
        if (mono) {
            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove(this.css.open);
            }
        }

        element.classList.add(this.css.open);

        this.openItem(content, contentHeight);
    }

    openItem(content, contentHeight) {
        gsap.set(content, {
            height: "auto",
            onComplete: () => {
                contentHeight = content.clientHeight;
                gsap.set(content, {
                    height: 0,
                    onComplete: () => {
                        gsap.to(content, 0.4, {
                            height: contentHeight,
                            onComplete: () => {
                                gsap.set(content, {
                                    height: "auto"
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    closeItem(accordion, element) {
        const active = this.getActiveElement(accordion, element);

        if (active) {
            let activeContent = active.querySelector(this.contentWrapperClass);

            if (activeContent == null) {
                activeContent = active.parentNode.querySelector(this.contentWrapperClass);
            }

            gsap.set(activeContent, {
                height: activeContent.offsetHeight
            });

            active.classList.remove(this.css.open);

            gsap.to(activeContent, 0.6, {
                height: 0
            });
        }
    }
}
